export const getMainState = (state) => state.holdings.mainState;
export const getSubCategory = (state) => state.holdings.subCategory;
export const getLimitData = (state) => state.holdings.limitData;
export const getOrderSeqArr = (state) => state.holdings.orderSeqArr;
export const getOsid = (state) => state.holdings.osid;
export const getSymbol = (state) => state.holdings.symbol;
export const getReportExtData = (state) => state.holdings.reportExtData;
export const getMsid = (state) => state.holdings.msid;
